import React from 'react';
import LoginLogoSrc from '../../images/LoginLogo.png';
import HeaderLogoSrc from '../../images/HeaderLogo.png';
import { Link } from 'react-router-dom';
import './Logo.css';

const Logo = props => (
  <Link to="/">
    {props.logoType === 'login' ? (
      <img
        data-qa="logo"
        {...props}
        src={LoginLogoSrc}
        alt="logo"
        className="u-ma-half"
      />
    ) : (
      <img
        data-qa="logo"
        {...props}
        src={HeaderLogoSrc}
        alt="logo"
        className="u-ma-half"
      />
    )}
  </Link>
);

export default Logo;
